import { api } from './customers'

export interface CustomerAppointment {
    id: number
    customerId: number
    appointmentDate: string
    appointmentTime: string
}

type CustomerAppointmentsResponse = CustomerAppointment[]


export const CustomerAppointmentApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCustomerAppointments: build.query<CustomerAppointmentsResponse, void>({
            query: () => 'appointment',
            providesTags: (result) =>
                result
                    ? [
                        ...result["data"]?.map(({ id }) => ({ type: 'CustomerAppointment' as const, id })),
                        { type: 'CustomerAppointment', id: 'LIST' },
                    ]
                    : [{ type: 'CustomerAppointment', id: 'LIST' }],
        }),
        addCustomerAppointment: build.mutation<CustomerAppointment, Partial<CustomerAppointment>>({
            query: (body) => ({
                url: `appointment`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: CustomerAppointment }, meta, arg) => response.data,
        }),
        getCustomerAppointment: build.query<CustomerAppointment, string>({
            query: (id) => `appointment/${id}`,
            transformResponse: (response: { data: CustomerAppointment }, meta, arg) => response.data,
        }),
        getCustomerAppointmentByCustomerId: build.query<CustomerAppointment[], string>({
            query: (id) => `get_appointmentBycustomerID/${id}`,
            transformResponse: (response: { data: CustomerAppointment[] }, meta, arg) => response.data,
        }),
        updateCustomerAppointment: build.mutation<void, Pick<CustomerAppointment, 'id'> & Partial<CustomerAppointment>>({
            query: ({ id, ...patch }) => ({
                url: `appointment/${id}`,
                method: 'PUT',
                body: patch,
            }),
        }),
        deleteCustomerAppointment: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `appointment/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetCustomerAppointmentQuery,
    useGetCustomerAppointmentsQuery,
    useGetCustomerAppointmentByCustomerIdQuery,
    useAddCustomerAppointmentMutation,
    useUpdateCustomerAppointmentMutation,
    useDeleteCustomerAppointmentMutation,
} = CustomerAppointmentApi

